<template>
<v-container fluid class="pa-0">

    <!-- <v-toolbar color="orange accent-1" style="position:fixed; left: 0px; top: 170px" floating dense>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn :disabled="!selection" v-on="on" icon @click="$store.commit('moveSelection')"><v-icon>flip_to_front</v-icon></v-btn>   
            </template>
            <span>Auswahl verschieben</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn :disabled="!selection" v-on="on" icon @click="$store.commit('deleteSelection')"><v-icon>delete</v-icon></v-btn>   
            </template>
            <span>Auswahl löschen</span>
        </v-tooltip>

    </v-toolbar> -->

    <div class="customNav" style="position:fixed; left: 0px; top: 70px;">

        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn :disabled="!selection" v-on="on" icon @click="$store.commit('moveSelection')"><v-icon>flip_to_front</v-icon></v-btn>   
            </template>
            <span>Auswahl verschieben</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn :disabled="!selection" v-on="on" icon @click="$store.commit('deleteSelection')"><v-icon>delete</v-icon></v-btn>   
            </template>
            <span>Auswahl löschen</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn :disabled="!selectionStab" v-on="on" icon @click="$store.commit('divideStab')"><v-icon style="transform: rotate(-45deg)">linear_scale</v-icon></v-btn>   
            </template>
            <span>Stab teilen</span>
        </v-tooltip>
    </div>



    <v-toolbar color="orange accent-1" style="position:fixed; right: 0px; top: 70px;" floating dense>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <form v-on="on" action="https://www.paypal.com/donate" method="post" target="_top">
                    <input type="hidden" name="hosted_button_id" value="88NXLEV9GD7GL" />
                    <input type="image" src="https://www.paypal.com/de_DE/i/btn/x-click-but04.gif" border="0" name="submit"/>
                    <img alt="" border="0" src="https://www.paypal.com/de_DE/i/scr/pixel.gif" width="1" height="1" />
                </form>
            </template>
            <span>Spenden</span>
        </v-tooltip>
    </v-toolbar>


    <v-toolbar color="orange accent-1" style="position:fixed; right: 0px; bottom: 201px;" floating dense>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('unhideAll')"><v-icon>visibility</v-icon></v-btn>   
            </template>
            <span>Alles einblenden</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn :disabled="!selection" v-on="on" icon @click="$store.commit('hideSelection')"><v-icon>visibility_off</v-icon></v-btn>   
            </template>
            <span>Auswahl ausblenden</span>
        </v-tooltip>
    </v-toolbar>
        
        <app-new-DLT></app-new-DLT>
        <app-new-BalkenkopfRep></app-new-BalkenkopfRep>

        <app-CMenuAuflager></app-CMenuAuflager>
        <app-CMenuGelenk></app-CMenuGelenk>
        <app-CMenuMaterial></app-CMenuMaterial>
        <app-CMenuQuerschnitt></app-CMenuQuerschnitt>
        <app-CMenuKnoten></app-CMenuKnoten>
        <app-CMenuStab></app-CMenuStab>
        <app-CMenuLastfall></app-CMenuLastfall>
        <app-CMenuKnotenlast></app-CMenuKnotenlast>
        <app-CMenuStablast></app-CMenuStablast>
        <app-CMenuPrint></app-CMenuPrint>

        <app-CMenuMoveSelection></app-CMenuMoveSelection>
        <app-CMenuDivideStab></app-CMenuDivideStab>

        <app-ColorMap></app-ColorMap>
    
    <v-alert v-model="viewAlert" :type="$store.getters.alert.type" >{{$store.getters.alert.msg}}</v-alert>  



    <div style="display: flex; flex-flow: column; height: 100vh">
    <v-toolbar color="orange accent-1" style="flex: 0 1 auto">
        <v-toolbar-title class="Seitenname title flex xs1">Rem-FEM</v-toolbar-title>
        <v-divider class="Seitenname" vertical></v-divider> 
        <v-menu offset-y >
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon><v-icon>insert_drive_file</v-icon></v-btn>
            </template>
            <v-list color="orange accent-1">
                <v-list-item>
                    <v-btn block @click="$store.dispatch('newSystem')">leeres System</v-btn>
                </v-list-item>
                <v-list-item>
                    <v-btn block @click="$store.commit('setvNewDLTMenu', true)">Durchlaufträger</v-btn>
                </v-list-item>
                <v-list-item>
                    <v-btn block @click="$store.commit('setvNewBalkenkopfRepMenu',true)">Balkenkopfreparatur</v-btn>
                </v-list-item>
                <v-list-item>
                    <v-btn disabled block @click="$store.dispatch('newSystem')">Kehlbalkendach</v-btn>
                </v-list-item>
                <v-list-item>
                    <v-btn disabled block @click="$store.dispatch('newSystem')">Pfettendach</v-btn>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="clickLoadFile()"><v-icon>folder_open</v-icon></v-btn><input type="file" style="display: none" accept=".rfs" ref="loadFile" @change="onFilePicked">
            </template>
            <span>Öffnen</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.dispatch('saveSystem')"><v-icon>save</v-icon></v-btn>   
            </template>
            <span>Speichern</span>
        </v-tooltip>
        <v-divider vertical></v-divider> 
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click.stop="$store.commit('newAuflager')"><v-icon x-large>$iconNewAuflager</v-icon></v-btn>   
            </template>
            <span>neues Auflager</span>
        </v-tooltip>   
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('newKnoten')"><v-icon x-large>$iconNewKnoten</v-icon></v-btn>
            </template>
            <span>neuer Knoten</span>
        </v-tooltip> 
        <v-divider vertical></v-divider> 
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('newMaterial')"><v-icon>widgets</v-icon></v-btn>   
            </template>
            <span>neues Material</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('newQuerschnitt')"><v-icon x-large>$iconQuerschnitt</v-icon></v-btn>   
            </template>
            <span>neuer Querschnitt</span>
        </v-tooltip>  
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('newGelenk')"><v-icon x-large>$iconNewGelenk</v-icon></v-btn>   
            </template>
            <span>neues Gelenk</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('newStab')"><v-icon large>timeline</v-icon></v-btn>   
            </template>
            <span>neuer Stab</span>
        </v-tooltip> 
        <v-divider vertical></v-divider> 
        <div class="flex xs2"></div>
        <h4 v-text="'Lastfall:'" class="mr-4"></h4>
        <v-select v-if="initStatus"
            no-data-text="kein Lastfall vorhanden"
            chips
            dense
            hide-details
            v-model="curLastfall"
            return-object
            width="290px"
            :items="Lastfallliste"
            :menu-props="{ offsetY: true }"
            item-text="name"
            @click:append-outer="$store.commit('newLastfall')"
            append-outer-icon="add"
            placeholder="wähle einen Lastfall..."
            solo>
        </v-select>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('newKnotenlast')"><v-icon large style="transform: rotate(90deg)">arrow_right_alt</v-icon></v-btn>
            </template>
            <span>neue Knotenlast</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.commit('newStablast')"><v-icon large>vertical_align_bottom</v-icon></v-btn>
            </template>
            <span>neue Stablast</span>
        </v-tooltip>
        <v-divider vertical></v-divider> 
        <v-tooltip bottom>
            <template v-slot:activator="{ on }"> 
            <v-btn v-if="curLastfall" v-on="on" icon @click="$store.dispatch('berechne', curLastfall)"><v-icon style="transform: rotate(180deg) scaleY(1.5)">keyboard</v-icon></v-btn>
            <v-btn v-else disabled icon><v-icon style="transform: rotate(180deg) scaleY(1.5)">keyboard</v-icon></v-btn>
            </template>
            <span>Berechnen</span>
        </v-tooltip>
        <v-divider vertical></v-divider>
        <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :disabled="!(curLastfall && curLastfall.Berechnet)">{{drawSchnittkraft}}</v-btn>
            </template>
            <v-card>
                <h4 class="pa-4">Ergebnissdarstellung:</h4>
                <v-divider></v-divider>
                <v-list color="orange accent-1">
                    <v-list-item>
                            <v-btn block @click="draw('-')">keine <v-icon small>block</v-icon></v-btn>
                    </v-list-item>
                    <v-list-item>
                            <v-btn block @click="draw('N')">Normalkraft</v-btn>
                    </v-list-item>
                    <v-list-item>
                            <v-btn block @click="draw('Q')">Querkraft</v-btn>
                    </v-list-item>
                    <v-list-item>
                            <v-btn block @click="draw('M')">Moment</v-btn>
                    </v-list-item>
                    <v-list-item>
                            <v-btn block @click="draw('W')">Verformung</v-btn>
                    </v-list-item>
                </v-list>
                    <v-divider></v-divider>
                <v-list>
                    <v-list-item>
                        <v-switch v-model="switchBelastung" @change="switchDrawBelastung()" label='Belastung'></v-switch> 
                    </v-list-item>
                    <v-list-item>
                            <v-switch v-model="switchAuflagerkräfte" @change="switchDrawAuflagerkräfte()" label='Auflagerkräfte'></v-switch>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>

        <v-divider vertical></v-divider> 
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="$store.dispatch('print')"><v-icon>print</v-icon></v-btn>
            </template>
            <span>Drucken</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="saveSvg(canvas,'test.svg')"><v-icon>photo</v-icon></v-btn>
            </template>
            <span>Download Zeichnung</span>
        </v-tooltip>


        <v-menu
        offset-y
        :close-on-content-click="false"
        >
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on"><v-icon>settings_applications</v-icon></v-btn>
            </template>
            <v-card>
                <h4 class="pa-4">Einstellungen</h4>
                <v-divider></v-divider>

                <v-list>
                <v-list-item> zur Zeit werden noch keine Einstellungen für den Nutzer angeboten.
                    <!-- <v-list-item-action> -->
                    <!-- <v-switch></v-switch> -->
                    <!-- </v-list-item-action> -->
                    <!-- <v-list-item-title></v-list-item-title> -->
                </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
    </v-toolbar>




    <!-- <v-alert dense type="info">Achtung: Das Programm befindet sich noch in der Entwicklung. Bitte bei Fehlfunktionen eine e-Mail an webmaster@remfem.de senden.</v-alert> -->
                <svg id="canvas1" class="text" style="flex: 1 1 auto; padding-top: 0px; margin-bottom:199px"></svg>
                <!-- <svg id="canvas1" class="text" style="width: 100vw; height: 100vh;"></svg> -->
    <v-footer absolute class="pa-0" style="flex: 1 1 auto">
        <v-tabs v-if="initStatus" dark fixed-tabs height="25px">
            <v-tab v-for="n in Tabellen" :key='n.name' ripple>{{n.name}}</v-tab>
                <v-tab-item fluid grid-list-md fill-height> <app-table-Auflager></app-table-Auflager> </v-tab-item>
                <v-tab-item fluid grid-list-md fill-height> <app-table-Knoten></app-table-Knoten> </v-tab-item>
                <v-tab-item fluid grid-list-md fill-height> <app-table-Material></app-table-Material> </v-tab-item>
                <v-tab-item fluid grid-list-md fill-height> <app-table-Querschnitt></app-table-Querschnitt> </v-tab-item>
                <v-tab-item fluid grid-list-md fill-height> <app-table-Gelenk></app-table-Gelenk> </v-tab-item>
                <v-tab-item fluid grid-list-md fill-height> <app-table-Stab></app-table-Stab> </v-tab-item>
                <v-tab-item fluid grid-list-md fill-height> <app-table-Lastfall></app-table-Lastfall> </v-tab-item>
        </v-tabs>
        <v-container fluid class="grey pa-0">&copy; Remigius Bachmann {{ new Date().getFullYear() }} <a href="mailto:webmaster@remfem.de?subject=REMFEM">webmaster@remfem.de</a>       
        
        </v-container>
    </v-footer>
    </div>

</v-container>
</template>

<script>
/* eslint-disable */
import * as d3 from 'd3'


(function () { // make vuetify dialogs movable
    const d = {};
    document.addEventListener("mousedown", e => {
        const closestDialog = e.target.closest(".v-dialog.v-dialog--active");
        if (e.button === 0 && closestDialog != null && e.target.classList.contains("v-card__title")) { // element which can be used to move element
            d.el = closestDialog; // element which should be moved
            d.mouseStartX = e.clientX;
            d.mouseStartY = e.clientY;
            d.elStartX = d.el.getBoundingClientRect().left;
            d.elStartY = d.el.getBoundingClientRect().top;
            d.el.style.position = "fixed";
            d.el.style.margin = 0;
            d.oldTransition = d.el.style.transition;
            d.el.style.transition = "none"
        }
    });
    document.addEventListener("mousemove", e => {
        if (d.el === undefined) return;
        d.el.style.left = Math.min(
            Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
            window.innerWidth - d.el.getBoundingClientRect().width
        ) + "px";
        d.el.style.top = Math.min(
            Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
            window.innerHeight - d.el.getBoundingClientRect().height
        ) + "px";
    });
    document.addEventListener("mouseup", () => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el = undefined
    });
    setInterval(() => { // prevent out of bounds
        const dialog = document.querySelector(".v-dialog.v-dialog--active");
        if (dialog === null) return;
        dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + "px";
        dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + "px";
    }, 100);
})();


export default {
    data(){
        return{
            Tabellen: [
                {name: 'Auflager'},
                {name: 'Knoten'},
                {name: 'Material'},
                {name: 'Querschnitt'},
                {name: 'Gelenk'},
                {name: 'Stab'},
                {name: 'Lastfälle'},
            ],
            drawSchnittkraft: '-',
            switchBelastung: true,
            switchAuflagerkräfte: true,
        }
    },

    computed: {
        selection() { return (this.$store.getters.Selection.Knoten.length > 0 || this.$store.getters.Selection.Stäbe.length > 0)},
        selectionStab() {return  this.$store.getters.Selection.Stäbe.length > 0},
        viewAlert() { return this.$store.getters.showAlert },
        initStatus() { return this.$store.getters.initStatus },
        canvas(){ return d3.select('#canvas1')},
        curLastfall: {
            get() { return this.$store.getters.curLastfall ? this.$store.getters.curLastfall : null },   
            set(value) { this.$store.commit('setCurLastfall', value)} 
        },
        Lastfallliste() {
            return this.$store.state.StatikSystem ? this.$store.state.StatikSystem.Lastfallliste : []
        }
    },
    methods: {
        draw(val){
            switch (val){
                case 'N':
                    this.drawSchnittkraft = 'N'
                    this.$store.commit('DRAW_NORMALKRAFT')  
                break  
                case 'Q':
                    this.drawSchnittkraft = 'Q'
                    this.$store.commit('DRAW_QUERKRAFT')
                break
                case 'M':
                    this.drawSchnittkraft = 'M'
                    this.$store.commit('DRAW_MOMENT') 
                break
                case 'W':
                    this.drawSchnittkraft = 'W'
                    this.$store.commit('DRAW_VERFORMUNG') 
                break
                case '-':
                    this.drawSchnittkraft = '-'
                    this.$store.commit('DRAW_KEINE_SCHNITTKRÄFTE') 
            }
        },
        switchDrawBelastung(){
            this.$store.commit('DRAW_BELASTUNG', this.switchBelastung)
        },

        switchDrawAuflagerkräfte(){
            this.$store.commit('DRAW_AUFLAGERKRÄFTE', this.switchAuflagerkräfte)
        },
        clickLoadFile(){
            this.$refs.loadFile.click()
        },
        onFilePicked(event){
            const files = event.target.files
            this.$store.dispatch('loadSystem', files[0])
            this.$refs.loadFile.value = ''
        },
        saveSvg(canvas,name) {
            var svgEl = canvas._groups["0"]["0"]
            svgEl.setAttribute("xmlns", "http://www.w3.org/2000/svg");
            var svgData = svgEl.outerHTML;
            var preface = '<?xml version="1.0" standalone="yes"?>\r\n';
            var svgBlob = new Blob([preface, svgData], {type:"image/svg+xml;charset=utf-8"});
            var svgUrl = URL.createObjectURL(svgBlob);
            var downloadLink = document.createElement("a");
            downloadLink.href = svgUrl;
            downloadLink.download = name;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        },
    },
    mounted() {
        this.$store.dispatch('initCanvas',{svg: d3.select('#canvas1'),width: undefined, height: undefined})
        .then(this.$store.dispatch('initStatikSystem'))
    }
}
</script>

<style>
@media (max-width: 1024px) {
  .Seitenname {
    visibility: hidden;
  }
}

.v-dialog.v-dialog--active .popup-header {
    cursor: grab;
    background-color: #FFD180;

    border-bottom-width: thin;
    border-bottom-style: solid;
    border-bottom-color: gray;
}
.v-dialog.v-dialog--active .popup-header:active {
    cursor: grabbing;
}
</style>

<style scoped>
/* body {
    background-color: rgb(128, 128, 128);
} */

.chart{
    background-color: white;
}

.customNav{
    background-color: #ffd180 !important;
    border-color: #ffd180 !important;
    color: rgba(0, 0, 0, 0.87);
    display: inline-flex;
    flex-wrap: wrap;
    width: 104px;
    padding-left:6px;
    -webkit-box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
    box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
}

.customNav button{
    width:48px;
    height: 48px;
    margin-right: -2px;
}
</style>